import $ from 'jquery';

$.fn.inlineEditable = function (commit, cancel) {
  this.addClass('text-editable');
  this.attr('contenteditable', 'true');
  this.off('focus').focus(function () {
    $(this).data('originalValue', $(this).text());
    return true;
  });

  this.off('blur').blur(function (e) {
    const oldVal = $(this).data('originalValue');
    const newVal = $(this).text();
    if (newVal !== oldVal) {
      $(this).data('originalValue', newVal);
      commit(e);
    }
  });

  this.off('keydown').keydown(function (e) {
    // Enter
    if (e.which === 13) {
      e.preventDefault();
      $(this).blur();
    }
    // Esc
    if (e.which === 27) {
      const oldVal = $(this).data('originalValue');
      $(this).text(oldVal);
      $(this).blur(); // This won't commit since original value == new value
      if (typeof cancel === 'function') {
        cancel(e);
      }
    }
  });
  return this;
};

$.fn.removeInlineEditable = function () {
  this.removeClass('text-editable');
  this.attr('contenteditable', 'false');
  this.off('focus');
  this.off('keydown');
  this.off('blur');
};
